import { openBiDirectionalChannel } from '../utils';
import { SUBSCRIBE_TO_EXTERNAL_APP_LOAD } from '../constants';
var onExternalAppLoad = params => {
  openBiDirectionalChannel(params, {
    type: SUBSCRIBE_TO_EXTERNAL_APP_LOAD
  });
};
export default onExternalAppLoad;